'use client';
import Counter from '@/components/counter/index';
import UKToast from '@/components/UKToast/index';
import { useTranslation } from '@/i18n/client';
import { useStores } from '@/models';
import { DP_EVENT_NAMES, dpBusinessLogger } from '@/utils/dpUtils/businessLogger';
import { observer } from 'mobx-react-lite';
import OpcDetail from '../opcDetail';
import PopoverWithIcon from '../popoverWithIcon';
import styles from './index.module.scss';

export default observer(function DpCounter({ productCommonFloor, selected_data }: any) {
  const { t } = useTranslation();
  const { dpStore } = useStores();
  const { productNumber, setProductNumber } = dpStore;

  const data = productCommonFloor?.data;
  const Basic_data = data?.['C-M#viewCommonItem&commonBasic'];
  const stockValue = Number(Basic_data?.maximumPurchaseLimit) || 200;
  const handleChangeNum = (num: number) => {
    dpBusinessLogger({
      eventName: DP_EVENT_NAMES.PRODUCT_COUNTER_CHANGE,
      message: {
        num,
      },
    });
    if (num < 1 || !data) {
      return;
    }
    if (num >= stockValue) {
      if (num === stockValue) {
        setProductNumber(num);
      }
      return UKToast.show({
        content: t('dp.purchaseLimitTip'),
        icon: 'warning',
      });
    }
    setProductNumber(num);
  };

  return (
    <div className={styles.counterBoxWrapper}>
      {/* 商品数量 */}
      <span className={styles.counterTitle}>{t('dp.qty')}</span>
      <Counter
        immediately={false}
        value={productNumber}
        minAmount={Basic_data?.minimumPurchaseLimit ? Number(Basic_data.minimumPurchaseLimit) : 1}
        maxAmount={Basic_data?.maximumPurchaseLimit ? Number(Basic_data.maximumPurchaseLimit) : 200}
        stock={stockValue}
        onChange={(num) => handleChangeNum(num)}
      />
      {selected_data?.purchaseDesc && (
        <div className={styles.purchaseLimitBox}>
          <span className={styles.purchaseLimitDesc}>{selected_data?.purchaseDesc}</span>
          <PopoverWithIcon>
            <OpcDetail
              title={selected_data?.purchasePop?.title}
              desc={selected_data?.purchasePop?.desc}
            />
          </PopoverWithIcon>
        </div>
      )}
    </div>
  );
});
